// echartsLaden.ts — lädt ECharts nach (dynamischer Import von echartsTeile.ts, Spec S19): ECharts landet in einem
// eigenen Chunk und wird erst geladen, wenn ein Diagramm erscheint; Board, Liste und Akte bleiben frei (Plan P14).
let halter = null;
/** Lädt echarts/core samt CustomChart, GridComponent, TooltipComponent, DataZoomComponent, MarkLineComponent,
 *  MarkAreaComponent, ToolboxComponent, CanvasRenderer genau einmal (Promise wird gehalten). Schlägt das Laden
 *  fehl (Netz, Chunk), wird nichts gehalten — der nächste Aufruf versucht es neu. */
export function ladeEcharts() {
    halter ??= import("./echartsTeile.js").catch((fehler) => {
        halter = null;
        throw fehler;
    });
    return halter;
}
/** Nur für Tests: setzt den gehaltenen Import zurück. */
export function _echartsVergessen() {
    halter = null;
}
//# sourceMappingURL=echartsLaden.js.map